import { RefObject, useState, useEffect } from "react";

interface Props {
    elementRef: RefObject<Element>;
    options?: object;
}
const UseIntersect = ({ options, elementRef }: Props): IntersectionObserverEntry | undefined => {
    const [entry, setEntry] = useState<IntersectionObserverEntry>();
    const updateEntry = ([entry]: IntersectionObserverEntry[]): void => {
        setEntry(entry);
    };

    useEffect(() => {
        const node = elementRef?.current; // DOM Ref
        const hasIOSupport = typeof window !== "undefined" && !!window.IntersectionObserver;
        if (!hasIOSupport || !node) return;

        const observer = new IntersectionObserver(updateEntry, options);
        observer.observe(node);

        return (): void => observer.disconnect();
    }, [elementRef, options]);

    return entry;
};

export default UseIntersect;
